import React, { useMemo } from 'react';

import { AnalyticsContext } from '@atlaskit/analytics-next';

import { useOnDismissDialog } from '../../../analytics/use-on-dismiss-dialog';
import { useEditionAwareness } from '../../../services/edition-awareness-context';
import { getHamsKey } from '../../../services/product-to-hams-key';
import { ModalEntryPoint } from '../shared/modal-entry-point';

import { DIALOG_CONFIG } from './dialog-config';
import { entryPoint, EntryPointParams } from './entrypoint';

export function PremiumAddPayment() {
	const { product, cloudId } = useEditionAwareness();

	const entryPointParams: EntryPointParams = useMemo(
		() => ({
			cloudId,
			hamsProductKey: getHamsKey(product),
		}),
		[cloudId, product],
	);

	const onClose = useOnDismissDialog({ ...DIALOG_CONFIG });

	const entryPointProps = useMemo(() => ({ onClose, product }), [onClose, product]);

	const modalProps = useMemo(() => ({ width: 968, height: 576, autoFocus: false }), []);

	return (
		<AnalyticsContext data={DIALOG_CONFIG}>
			<ModalEntryPoint
				entryPointProps={entryPointProps}
				entryPoint={entryPoint}
				entryPointParams={entryPointParams}
				modalProps={modalProps}
			/>
		</AnalyticsContext>
	);
}
